import * as DigitalAssetApi from '../api/DigitalAssetApi';
import {addSectionToReport} from '../ducks/reportSections';
import {updatePreferences} from './preferences';

const convertToReadUrl = function (uploadUrl) {
  return uploadUrl.split('?')[0];
};

export function truncatedFilename(filename) {
  return filename && filename.substring(0, filename.lastIndexOf('.')).substr(0, 20);
}

export default function uploadPdf(reportType, file) {
  return async (dispatch, getState) => {
    const {propertyDetail} = getState();
    DigitalAssetApi.uploadDigitalAsset({
      file,
      source: 'upload-custom-pdf',
      propertyId: propertyDetail.propertyId,
    }).then(response => {
      if (response.status === 201) {
        let readUrl = convertToReadUrl(response.data.url);
        dispatch(addSectionToReport(reportType, readUrl, file.name));
        let preference = {};
        preference[`custom[${readUrl}].included`] = 'true';
        preference[`custom[${readUrl}].filename`] = file.name;
        preference[`custom[${readUrl}].uiLabel`] = truncatedFilename(file.name);
        dispatch(updatePreferences(preference, reportType));
      }
      else{
        console.log('Upload not completed, http status',response.status);
      }
    }).catch(e => {
      console.log('Failed to upload the document');
    });
  };
}